<template>
  <div class="user_container">
    <div class="carManageContainer">
      <div class="tabsContainer">
        <van-tabs v-model="active" color="#4EA27C" line-height="4px" line-width="20px" @click="switchCarStatus">
          <van-tab title="正常">
            <div class="carLists">
              <div class="awaitAllotContainer">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div class="awaitAllot" v-for="(item, index) in carInfoList" :key="index">
                    <div class="awaitAllotTitle">
                      <div class="awaitAllotDriver">
                        <img :src="carImgList.useCarImg" alt="" />
                        <span>{{ item.carBrand }}</span>
                      </div>
                      <div class="tabBtn" :class="item.useState == '0'
                        ? 'btnColorBule'
                        : 'btnColorGreen'
                        ">
                        <span>{{
                          item.useState == "1" ? "使用中" : "空闲"
                        }}</span>
                      </div>
                      <div class="checkbox">
                        <van-checkbox v-model="item.checked" @click="selectCheckbox(item, index)"></van-checkbox>
                      </div>
                    </div>
                    <div class="userInfo">
                      <div class="info">人数：{{ item.maxCapacity }}</div>
                      <div class="info">司机：{{ item.driverName }}</div>
                      <div class="info">联系方式：{{ item.driverPhone }}</div>
                    </div>
                  </div>
                </van-list>
              </div>

              <div class="footerBtn">
                <van-button type="default" size="small" style="width: 24%" @click="deleteCarInfo">删除</van-button>
                <van-button type="info" size="small" @click="freezeCar"
                  style="width: 24%; background-color: #4ea27c">预留</van-button>
                <!-- v-if="checkedItems.length!==1" -->
                <van-button type="info" size="small" @click="addCar"
                  style="width: 24%; background-color: #e86d6d">添加</van-button>
                <van-button type="info" size="small" @click="editCarInfo"
                  style="width: 24%; background-color: #e86d6d">编辑</van-button>
              </div>
            </div>
          </van-tab>
          <van-tab title="已预留">
            <div class="carLists">
              <div class="awaitAllotContainer freezeContainer">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div class="awaitAllot" v-for="(item, index) in carInfoList" :key="index">
                    <div class="awaitAllotTitle awaitAllotTitle1">
                      <div class="carTitleItem">
                        <div class="awaitAllotDriver">
                          <img :src="carImgList.useCarImg" alt="" />
                          <span>{{ item.carBrand }}</span>
                        </div>
                        <div class="tabBtn btnColorBule">
                          <span>预留</span>
                        </div>
                      </div>
                      <div class="unfreeze" @click="unfreeze(item)">
                        取消预留
                      </div>
                    </div>
                    <div class="userInfo">
                      <div class="info">人数：{{ item.maxCapacity }}</div>
                      <div class="info">司机：{{ item.driverName }}</div>
                      <div class="info">联系方式：{{ item.driverPhone }}</div>
                      <div class="info">预留时间：{{ item.freezeStartTime }} - {{ item.freezeEndTime }}</div>
                    </div>
                  </div>
                </van-list>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div>
          <van-dialog v-model="freezeTimeDialog" title="" :showConfirmButton="false">
            <div class="dateDialog">
              <van-form ref="form">
                <van-field :rules="[{ required: true }]" v-model="freezeStartTime" label="预留开始时间" placeholder="请输入预留开始时间"
                  readonly @click="handlerFreezeStart" />
                <van-field :rules="[{ required: true }]" v-model="freezeEndTime" label="预留结束时间" placeholder="请输入预留结束时间"
                  readonly @click="handlerFreezeEnd" />
              </van-form>
            </div>
            <div class="dialogFooterBtn">
              <div class="btn" @click="dialogCancel">取消</div>
              <div class="btn" @click="dialogConfirm">确认</div>
            </div>
          </van-dialog>
          <van-popup v-model="showFreezeStartTime" position="bottom">
            <van-datetime-picker v-model="freezeStartDate" type="datetime" title="选择年月日" @confirm="comfirmFreezeStart"
              @cancel="showFreezeStartTime = false" />
          </van-popup>
          <van-popup v-model="showFreezeEndTime" position="bottom">
            <van-datetime-picker v-model="freezeEndTimeDate" type="datetime" title="选择年月日" @confirm="comfirmFreezeEnd"
              @cancel="showFreezeEndTime = false" />
          </van-popup>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car";
import "@/assets/car/icon/iconfont.css";
import moment from "moment";
export default {
  name: "carManage",
  data() {
    return {
      active: 0,
      carImgList: {
        useCarImg: require("@/assets/car/useCar.png"),
        notUserCarIMg: require("@/assets/car/greenCar.png")
      },
      loading: false,
      finished: false,
      carInfoList: [],
      checkedItems: [],
      totalAll: 0,
      page: 1,
      pageSize: 20,
      freezeTimeDialog: false,
      showFreezeStartTime: false,
      freezeStartDate: new Date(),
      freezeStartTime: '', //冻结开始时间
      showFreezeEndTime: false,
      freezeEndTime: '',//冻结结束时间
      freezeEndTimeDate: new Date()
    };
  },
  created() { },
  mounted() { },
  methods: {
    // 车辆信息
    getCarInfo(carState) {
      this.carInfoList = [];
      const json = {
        page: this.page,
        pageSize: this.pageSize,
        carState: carState,
        zoneId: localStorage.getItem('cityId')
      };
      apis
        .queryCarListInfo(json)
        .then(res => {
          if (res.code === 200) {
            this.totalAll = res.data.total;
            this.finished = false;
            if (this.page === 1) {
              this.carInfoList = res.data.list;
            } else {
              this.carInfoList = this.carInfoList.concat(res.data.list);
            }
            if (this.carInfoList.length < this.totalAll) {
              this.page = this.page + 1;
            } else {
              this.finished = true;
            }
            this.loading = false;

            this.carInfoList = this.carInfoList.map(item => {
              item.checked = false;
              item.freezeStartTime = moment(item.freezeStartTime).format("YYYY-MM-DD HH:mm");
              item.freezeEndTime = moment(item.freezeEndTime).format("YYYY-MM-DD HH:mm");
              return item;
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // tabs切换
    switchCarStatus() {
      this.page = 1;
      this.onLoad();
    },
    onLoad() {
      this.getCarInfo(this.active);
    },
    //多选框 选中
    selectCheckbox(item, itemIndex) {
      this.checkedItems = [];
      if (item.checked) {
        this.checkedItems.push(item);
      }
      this.carInfoList = this.carInfoList.map((i, index) => {
        if (item.checked) {
          if (index === itemIndex) {
            i.checked = true;
          } else {
            i.checked = false;
          }
        }
        return i;
      });
      this.checkedItems.map((obj, index) => {
        if (!obj.checked) {
          this.checkedItems.splice(index, 1);
        }
      });
    },
    //添加
    addCar() {
      const carInfo = {};
      sessionStorage.removeItem("addcarInfo");
      this.$store.dispatch("getCarDetailInfo", carInfo);
      this.$router.replace("/car/facility/carManage/addCar");
    },

    //冻结
    freezeCar() {
      if (this.checkedItems.length < 1) {
        return this.$toast("请选择一条信息进行预留");
      }
      // const useState = this.checkedItems.map(item => item.useState);
      // if (useState.toString() == 1) {
      //   this.$toast.fail("使用中车辆不能冻结");
      //   return;
      // }
      this.freezeTimeDialog = true;
    },
    //删除
    deleteCarInfo() {
      if (this.checkedItems.length < 1) {
        return this.$toast("请选择一条信息进行删除");
      }
      this.$dialog
        .confirm({
          message: "您确定要删除该车辆信息吗？"
        })
        .then(() => {
          if (this.checkedItems.length > 0) {
            const useState = this.checkedItems.map(item => item.useState);
            if (useState.toString() == 1) {
              this.$toast.fail("使用中车辆不能删除");
              return;
            }
            const id = this.checkedItems.map(item => item.id).toString();
            apis.deleteCarListInfo(Number(id)).then(res => {
              if (res.code === 200) {
                this.page = 1;
                this.onLoad();
                this.$toast.success("删除成功");
              }
            });
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    //编辑车辆信息
    editCarInfo() {
      if (this.checkedItems.length > 0) {
        const info = { ...this.checkedItems[0] };
        localStorage.setItem("driverCarInfo", JSON.stringify(info));
        this.$router.replace("/car/facility/carManage/addCar");
      } else {
        this.$toast("请选择一条信息进行修改");
      }
    },
    //解冻
    unfreeze(item) {
      this.$dialog
        .confirm({
          message: "您确定要取消预留该车辆吗？"
        })
        .then(() => {
          const json = {
            id: item.id,
            carState: 0
          };

          apis.freezeChangeStateApi(json).then(res => {
            if (res.code === 200) {
              this.page = 1;
              this.onLoad();
              this.$toast.success("预留成功");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 弹框取消
    dialogCancel() {
      this.freezeTimeDialog = false;
    },
    //弹框确认
    dialogConfirm() {
      this.$refs.form
        .validate()
        .then(() => {
          const isBefore = moment(this.freezeStartTime).isBefore(this.freezeEndTime);
          if (isBefore) {
            this.freezeTimeDialog = false;
            const carInfo = this.checkedItems.map(item => item.id).toString();
            const json = {
              id: carInfo,
              carState: 1,
              freezeStartTime: this.freezeStartDate,
              freezeEndTime: this.freezeEndTimeDate
            };

            apis.freezeChangeStateApi(json).then(res => {
              if (res.code === 200) {
                this.page = 1;
                this.onLoad();
                this.$toast.success("预留成功");
              }
            });
          } else {
            this.$toast("预留开始时间不能大于等于结束时间");
          }

        });

    },
    //点击开始冻结时间
    handlerFreezeStart() {
      this.showFreezeStartTime = true;
    },
    // 时间确认
    comfirmFreezeStart(value) {
      this.freezeStartDate = value;
      this.freezeStartTime = moment(value).format("YYYY-MM-DD HH:mm");
      this.showFreezeStartTime = false;
    },
    // 点击结束冻结时间
    handlerFreezeEnd() {
      this.showFreezeEndTime = true;
    },
    // 时间确认
    comfirmFreezeEnd(value) {
      this.freezeEndTimeDate = value;
      this.freezeEndTime = moment(value).format("YYYY-MM-DD HH:mm");
      this.showFreezeEndTime = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }

  ::v-deep .van-popup {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }

  ::v-deep .van-popup {
    width: 276px * $zoom;
    left: initial;
  }
}

.user_container {
  margin: auto;

  .carManageContainer {
    .tabsContainer {
      width: 100%;
      background-color: #fff;

      ::v-deep(.van-tabs__wrap) {
        width: 300px;
        height: 105px;
      }

      ::v-deep(.van-tab) {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      ::v-deep(.van-tab--active) {
        font-size: 36px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #282b32;
      }

      ::v-deep(.van-tabs__line) {
        border-radius: 0 !important;
      }
    }

    .carLists {
      display: flex;
      flex-direction: column;
      height: 91.3vh;

      .awaitAllotContainer {
        // width: 680px;
        flex: 1;
        padding: 0 29px;
        // height: calc(84vh);
        background-color: #f7f9fa;
        overflow-y: auto;

        &::-webkit-scrollbar {
          display: none;
        }

        .awaitAllot {
          background-color: #fff;
          margin-top: 20px;
          border-radius: 9px;
          padding: 0 26px;

          .awaitAllotTitle {
            display: flex;
            align-items: center;
            padding-top: 5px;
            position: relative;

            ::v-deep(.van-checkbox__icon .van-icon) {
              width: 30px;
              height: 30px;
            }

            ::v-deep .van-icon-success:before {
              height: 30px;
            }

            .awaitAllotDriver {
              font-size: 36px;
              font-family: PingFang-SC-Bold, PingFang-SC;
              font-weight: bold;
              color: #282b32;
              // margin: 0 20px;
              margin-right: 20px;
              padding-top: 36px;

              img {
                width: 44px;
                height: 36px;
                margin-right: 16px;
              }
            }

            .tabBtn {
              // width: 106px;
              height: 40px;
              line-height: 40px;
              text-align: center;

              border-radius: 6px;
              padding: 0 10px;
              margin-top: 36px;
              // opacity: 0.1;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .btnColorGreen {
              background-color: #edf5f2;
              color: #4ea27c;
            }

            .btnColorBule {
              background-color: #eaf1fc;
              color: #2c76e3;
            }

            .checkbox {
              position: absolute;
              right: 0;
              top: 20px;
            }
          }

          .awaitAllotTitle1 {
            display: flex;
            justify-content: space-between;

            .carTitleItem {
              display: flex;
              align-items: center;

              .awaitAllotDriver {
                font-size: 36px;
                font-family: PingFang-SC-Bold, PingFang-SC;
                font-weight: bold;
                color: #282b32;
                // margin: 0 20px;
                margin-right: 20px;
                padding-top: 36px;

                img {
                  width: 44px;
                  height: 36px;
                  margin-right: 16px;
                }
              }
            }

            .unfreeze {
              font-size: 24px;
              margin-top: 36px;
              color: #2c76e3;
              border: 1px solid #2c76e3;
              padding: 5px 10px;
              border-radius: 10px;
            }
          }

          .userInfo {
            margin-top: 25px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #282b32;

            .info {
              padding-bottom: 20px;
            }
          }
        }
      }
    }

    .freezeContainer {
      height: calc(91vh) !important;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    @media screen and (max-width: 600px) {
      .footerBtn {
        width: 100%;
      }
    }

    @media screen and (min-width: 600px) {
      .footerBtn {
        width: 276px * $zoom;
      }
    }

    .footerBtn {
      padding: 20px 0;
      // position: fixed;
      // bottom: 0;
      height: 120px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .van-button {
        height: 84px;
        border: 0;
        border-radius: 20px;
        font-size: 28px;
      }
    }
  }
}

.dateDialog {
  padding: 20px;
}

.dialogFooterBtn {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100px;

  .btn {
    text-align: center;
    font-size: 26px
  }
}
</style>
